import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import FeedbackWidget from './feedback-widget';
import * as mopinion from 'core/script/components/customer-feedback/mopinion-loader';
import uiActions from 'state/actions/ui';
import { getMessagingRemoteUrl } from '../../../../Areas/MyTradera/static/script/app/helpers/messaging-helpers';
import './messaging-iframe.scss';

const MESSAGING_FEEDBACK_ID = 'messaging-feedback-widget';
const MESSAGING_LOCAL_PATH = '/messaging';
const POST_MESSAGE_TYPE_PREFIX = 'tradera.messaging.';
const MESSAGING_REMOTE_URL = getMessagingRemoteUrl(location.hostname);

class MessagingIframe extends React.Component {
    constructor(props) {
        super(props);
        this.iframeRef = React.createRef();
    }

    /**
     * Extract messaging part of current url, i.e. /messaging/...
     *
     * @param {string} currentPath
     * @returns {string}
     */
    getMessagingUrl(currentPath) {
        const {
            initData: { memberId }
        } = this.props;
        let url = MESSAGING_REMOTE_URL;
        if (currentPath.startsWith(MESSAGING_LOCAL_PATH)) {
            url += currentPath.substr(MESSAGING_LOCAL_PATH.length);
        }
        // Provide logged in user id to messaging
        url += qs.stringify(
            {
                traderaUserId: memberId
            },
            { addQueryPrefix: true }
        );
        return url;
    }

    /**
     * Post message to iframe
     *
     * @param {string} type
     * @param {any} [data]
     */
    sendMessage = (type, data) => {
        if (this.iframeRef.current) {
            this.iframeRef.current.contentWindow.postMessage(
                { type: POST_MESSAGE_TYPE_PREFIX + type, data },
                '*'
            );
        }
    };

    /** Handle incoming posted messages from iframe
     *
     * @param event
     */
    handleMessage = event => {
        const {
            data: { type, data },
            origin
        } = event;
        const {
            dispatch,
            initData: { memberId }
        } = this.props;
        if (origin !== MESSAGING_REMOTE_URL) {
            return;
        }
        switch (type) {
            // Sync navigation from messaging
            case POST_MESSAGE_TYPE_PREFIX + 'navigation':
                /* Navigation in iframe automatically adds history to containing page,
                   replace it with history entry sent from iframe to add state with pathname
                   so popping history state sets the correct url */
                window.history.replaceState(
                    {
                        pathname: data.pathname
                    },
                    window.document.title,
                    MESSAGING_LOCAL_PATH + data.pathname
                );
                break;
            // Feedback widget click
            case POST_MESSAGE_TYPE_PREFIX + 'feedback':
                // window.mopinionIdForMessaging is configured in Google Tag Manager
                if (window.mopinionIdForMessaging) {
                    mopinion.addScriptToDom();
                    mopinion.loadMopinionWidget(
                        memberId,
                        window.mopinionIdForMessaging
                    );
                    mopinion.openMopinionWidget();
                } else {
                    document.getElementById(MESSAGING_FEEDBACK_ID).click();
                }

                break;
            // Unread threads update
            case POST_MESSAGE_TYPE_PREFIX + 'unreadThreads':
                dispatch(
                    uiActions.updateMessagingNotifications(data, Date.now())
                );
                break;
        }
    };

    /**
     * Handle navigation events on messaging page
     *
     * @param event
     */
    handlePopState = event => {
        // Sync navigation to messaging
        if (event.state && 'pathname' in event.state) {
            this.sendMessage('navigation', {
                pathname: event.state.pathname
            });
        }
    };

    /**
     * Handle navigation events on messaging page
     *
     * @param event
     */
    handlePopState = event => {
        // Sync navigation to messaging
        if (event.state && 'pathname' in event.state) {
            this.sendMessage('navigation', {
                pathname: event.state.pathname
            });
        }
    };

    componentDidMount() {
        window.addEventListener('message', this.handleMessage);
        window.addEventListener('popstate', this.handlePopState);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
        window.removeEventListener('popstate', this.handlePopState);
    }

    render() {
        const src = this.getMessagingUrl(
            document.location.pathname + document.location.search
        );
        return (
            <Fragment>
                <iframe
                    className="messaging-iframe"
                    scrolling="no"
                    src={src}
                    ref={this.iframeRef}
                />
                <FeedbackWidget
                    id={MESSAGING_FEEDBACK_ID}
                    className="d-none"
                    uniqueKey="messaging"
                    subtitle="Hur tycker du att det fungerar att skicka och ta emot meddelanden?"
                    title=""
                    likeLabel="Bra"
                    dislikeLabel="Dåligt"
                />
            </Fragment>
        );
    }
}

// eslint-disable-next-line
const mapStateToProps = (state, ownProps) => {
    return {
        initData: state.initData
    };
};

export default connect(mapStateToProps)(MessagingIframe);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/messaging/messaging-iframe.jsx